import { computed, Ref, ref } from 'vue'

export function useArrowKeyGridNavigation(itemsPerRow: Ref<number>, itemCount: Ref<number>) {
  const currentFocusIndex = ref<number | null>(null)
  const itemsInFullRowsCount = computed(() => {
    return itemCount.value - (itemCount.value % itemsPerRow.value || itemsPerRow.value)
  })

  const focusNextItem = (currentIndex: number): void => {
    const nextIndex = (currentIndex + 1) % itemCount.value
    currentFocusIndex.value = nextIndex
  }

  const focusPreviousItem = (currentIndex: number): void => {
    const previousIndex = (currentIndex - 1 + itemCount.value) % itemCount.value
    currentFocusIndex.value = previousIndex
  }

  const focusItemNextRow = (currentIndex: number): void => {
    const nextIndex =
      currentIndex + itemsPerRow.value < itemCount.value
        ? currentIndex + itemsPerRow.value
        : currentIndex % itemsPerRow.value

    currentFocusIndex.value = nextIndex
  }

  const focusItemPreviousRow = (currentIndex: number): void => {
    let previousIndex: number
    if (currentIndex - itemsPerRow.value >= 0) {
      previousIndex = currentIndex - itemsPerRow.value
    } else {
      previousIndex = currentIndex + itemsInFullRowsCount.value
      if (currentIndex + itemsInFullRowsCount.value >= itemCount.value) {
        previousIndex -= itemsPerRow.value
      }
    }
    currentFocusIndex.value = previousIndex
  }

  const onItemFocus = (index: number): void => {
    currentFocusIndex.value = index
  }

  const onItemBlur = (index: number): void => {
    if (currentFocusIndex.value === index) {
      currentFocusIndex.value = null
    }
  }

  const onKeyDown = (event: KeyboardEvent): void => {
    if (currentFocusIndex.value === null) return
    switch (event.key) {
      case 'ArrowRight':
        focusNextItem(currentFocusIndex.value)
        break
      case 'ArrowLeft':
        focusPreviousItem(currentFocusIndex.value)
        break
      case 'ArrowDown':
        focusItemNextRow(currentFocusIndex.value)
        break
      case 'ArrowUp':
        focusItemPreviousRow(currentFocusIndex.value)
        break
      default:
        return
    }
  }

  return {
    currentFocusIndex,
    focusNextItem,
    focusPreviousItem,
    focusItemNextRow,
    focusItemPreviousRow,
    onItemFocus,
    onItemBlur,
    onKeyDown
  }
}
